<template>
  <div class="news-preview content-box" :class="classes">
    <template v-if="previewType === 'highlight'">
      <div v-if="!noImage" class="image" :style="{ backgroundImage: backgroundImage }" @click="navigate({ name: 'companyStory', params: { id: newsItem.mainEntity.id, storyTitle: newsItem.slugTitle, storyId: newsItem.uniqueId } })"></div>
      <div class="content">
        <div class="info text-semimuted"><router-link exact :to="{ name: relatedEntity.type, params: { id: relatedEntity.id, name: $store.state.names[relatedEntity.lassoId] } }">{{relatedEntity.name}}</router-link>, {{newsItem.time | timeSince}}</div>
        <h3><router-link exact :to="{ name: 'companyStory', params: { id: newsItem.mainEntity.id, storyTitle: newsItem.slugTitle, storyId: newsItem.uniqueId } }">{{newsItem.prettyHeadline}}</router-link></h3>
      </div>
    </template>

    <template v-else-if="previewType === 'basic'">
      <div v-if="!noImage && newsItem.provider.toLowerCase() !== 'ritzau'" class="image" :class="[ isRelatedNews && 'plausible-event-name=related+news+click' ]" :style="{ backgroundImage: backgroundImage }" @click.self="navigate({ name: 'companyStory', params: { id: newsItem.mainEntity.id, storyTitle: newsItem.slugTitle, storyId: newsItem.uniqueId } })">
      </div>

      <!-- Currently, ritzau news are filtered out in the backend, but it could be re-instated as a freemium feature tease
      <div v-if="newsItem.provider.toLowerCase() === 'ritzau'" class="image" style="background: #10253E" @click.self="ritzauTrialClick">
        <img class="via-ritzau" src="../assets/img/svg/ritzau_logo_white.svg" alt="">
        <p class="date">{{newsItem.time | date('%d-%m-%Y') | monthFormat }}</p>
      </div> -->

      <div class="content">
        <div class="info text-semimuted"><router-link exact :class="[ relatedEntity.lassoId.indexOf('CVR-1-') === 0 && 'plausible-event-name=company+click+link' ]" :to="{ name: relatedEntity.type, params: { id: relatedEntity.id, name: $store.state.names[relatedEntity.lassoId] } }">{{relatedEntity.name}}</router-link>, {{newsItem.time | timeSince}}</div>

        <h3>
          <router-link
            v-if="newsItem.provider.toLowerCase() !== 'ritzau'"
            exact
            :class="[ isRelatedNews && 'plausible-event-name=related+news+click' ]"
            :to="{ name: 'companyStory', params: { id: newsItem.mainEntity.id, storyTitle: newsItem.slugTitle, storyId: newsItem.uniqueId } }"
            v-html="newsItem.prettyHeadline"
          />

          <!-- <a
            v-else
            @click.self="ritzauTrialClick"
            v-html="newsItem.prettyHeadline"
          /> -->
        </h3>

        <p
          class="text-semimuted"
          v-html="$options.filters.linkify(previewContent, true, 120)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { EventBus } from '@/assets/js/helpers.js'
import filters from '@/assets/js/filters.js'
import windowSize from '@/window-size'
export default {
  name: 'newsPreview',
  components: {},
  props: {
    'newsItem': {
      type: Object,
      required: true
    },
    'previewType': {
      type: String, // basic, highlight
      required: true
    },
    'queryRelated': {
      type: Boolean,
      required: false,
      default: false
    },
    isRelatedNews: {
      type: Boolean,
      required: true,
    },
    'sizing': {
      type: String, // tall, narrow
      required: false
    },
    'noImage': {
      type: Boolean, // tall, narrow
      required: false
    },
    context: {
      type: String,
      required: false
    },
    maxWidth: {
      type: String
    }
  },
  data () {
    return {
      deferred: false,
    }
  },
  filters: {
    monthFormat: function (date) {
      let dateSplit = date.split('-')
      return filters.monthName(parseInt(dateSplit[1]) - 1) + ', ' + dateSplit[0]
    }
  },
  mounted() {
    addEventListener("scroll", (event) => this.deferred = true, { once: true })
  },
  computed: {
    previewContent: function () {
      return this.newsItem.content.replace(new RegExp('/li>', 'g'), '/li>, ').replace(/<[^>]*>/g, '')
    },
    classes: function () {
      var classNames = {}
      classNames[this.previewType] = true
      if (this.sizing) classNames[this.sizing] = true
      return classNames
    },
    date: () => {
      return new Date()
    },
    relatedEntity: function () {
      return this.queryRelated ? this.newsItem.queryEntity : this.newsItem.mainEntity
    },
    backgroundImage: function () {
      if (this.newsItem.deferLoad && !this.deferred) return ''
      let size = windowSize.size
      if (size === 'xxs' || this.maxWidth === 'xxs') return 'url(' + this.newsItem.imageId.replace('.jpg', '_480.jpg') + ')'
      if (size === 'xs' || this.maxWidth === 'xs') return 'url(' + this.newsItem.imageId.replace('.jpg', '_768.jpg') + ')'
      if (size === 'sm' || this.maxWidth === 'sm') return 'url(' + this.newsItem.imageId.replace('.jpg', '_992.jpg') + ')'
      if (size === 'md' || this.maxWidth === 'md') return 'url(' + this.newsItem.imageId.replace('.jpg', '_1200.jpg') + ')'
      if (size === 'lg' || this.maxWidth === 'lg') return 'url(' + this.newsItem.imageId.replace('.jpg', '_1200.jpg') + ')'
      return ''
    }
  },
  methods: {
    navigate (config) {
      EventBus.$emit('navigate', config)
    },
  }
}
</script>

<style lang="less" scoped>
@import (reference) "~@oldShared/lasso/style/constants/colors";
  // rules to keep in mind
  // narrow (1/4 wide or less) can be visible from sm and up

  .content-box {
    padding: 0;
  }

  .news-preview {
    position: relative;
    .image {
      background-size: cover;
      cursor: pointer;
      border-radius: 3px 3px 0 0;
      opacity: 1;
      position: relative;
      .via-ritzau {
        width: 180px;
        position: absolute;
        top: 20px;
        left: 30px;
      }
      .date {
        position: absolute;
        top: 55px;
        left: 30px;
        color: #517c92;
      }

    }

    button.follow-button {
      position: absolute;
      right: 20px;
      top: 20px;
      box-shadow: 0 0 10px -5px rgb(0, 0, 0, 0.5) !important;
    }

    .content {
      // min-height: 200px;
      padding: 30px 30px;

      .info {
        font-size: 14px;
      }

      h3 {
       color: #212121;
       font-size: 24px;
       font-weight: 500;
       margin: 10px 0 15px 0;
       word-break: break-word;

       a {
         color: inherit;
         cursor: pointer;
         &:hover {
           color: #FF8E61;
           text-decoration: none;
         }
       }
      }

      p {
        word-break: break-word;
        margin: 0;
        line-height: 26px;
      }
    }

    &.highlight {
      .image {
        min-height: 200px;
      }
      .content {
        h3 {
          font-size: 33px;
        }
      }
    }

    &.basic {
      .image {
        min-height: 200px;
      }
    }
  }

  #app.xxs .news-preview {
    .image {
      border-radius: 0;
    }
  }

  #app.min-xs .news-preview {
    &.highlight {
      .image {
        min-height: 200px;
      }
    }
  }

  #app.min-sm .news-preview {
    &.highlight {
      .image {
        min-height: 275px;
      }
      .content {
        h3 {
          margin-bottom: 0;
        }
      }
    }

    &.basic {
      &.narrow {
        .image {
          min-height: 150px;
        }
        h3 {
          font-size: 20px;
        }
      }

      &.tall {
        .image {
          min-height: 250px;
        }
      }
    }
  }

  #app.min-md {
    .news-preview {
      &.highlight {
        display: flex;
        align-items: stretch;
        .image {
          width: 50%;
          min-height: 200px;
          border-radius: 3px 0 0 3px;
        }
        .content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          h3 {
            margin-bottom: inherit
          }
        }
      }
      &.basic {
        &.narrow {
          .image {
            min-height: 150px;
          }
          h3 {
            font-size: 20px;
          }
        }

        &.tall {
          .image {
            min-height: 300px;
          }
        }
      }
    }
    .col-md-3 {
      .news-preview.narrow {
        button.follow-button.ritzau {
          display: none;
        }
        &:hover {
          button.follow-button.ritzau {
            display: block;
          }
        }
      }
    }
  }

  #app.md .news-preview {
    &.basic {
      &.narrow {
        .image {
          .via-ritzau {
            width: 150px;
          }
          .date {
            top: 50px;
          }
        }
      }
    }
  }

  #app.lg .news-preview {
    &.highlight {
      .image {
        width: 58.333%;
      }
    }
  }


</style>
